<app-menu [isRenderMenu]="false" [menuModuleEnum]="menuModuleEnum"></app-menu>


<div class="container-body">
  <div class="vertical-aling-out">
    <div class="vertical-aling-inner">
      <div class="white-box">
        <h2>Redefinir senha</h2>
        <form class="form" [formGroup]="model"  (ngSubmit)="submit()">
          <p>Insira a matricula ou CPF associado à sua conta para receber um link de redefinição de senha.</p>
          @if (!state) {
            <div class="row label-row">
              <div class="col-md-12 login-label" (click)="changeState()">
                <mat-icon class="vertical-align" aria-hidden="false" aria-label="Plus">account_circle</mat-icon>{{model.get('login').value}}
              </div>
            </div>
          }
          @if (state) {
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline">
                  <mat-label>Matricula ou CPF</mat-label>
                  <input matInput type="text" formControlName="login" required>
                  @if (model.get('login').invalid) {
                    <mat-error>Informe a sua matricula ou cpf</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          }
          @if (listHealthUnit && listHealthUnit.length>1) {
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline">
                  <mat-label>Unidade de Saude</mat-label>
                  <mat-select formControlName="idHealthUnit">
                    @for (item of listHealthUnit; track item) {
                      <mat-option value="{{item.idHealthUnit}}">{{item.healthUnitName}}</mat-option>
                    }
                  </mat-select>
                  @if (model.get('idHealthUnit').invalid) {
                    <mat-error>Informe a unidade de saúde</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          }
          @if (state) {
            <div class="row">
              <div class="col-md-12">
                <mat-radio-group aria-label="Select an option" [(ngModel)]="recoverOption" [ngModelOptions]="{standalone: true}">
                  <mat-radio-button value="1">Email</mat-radio-button>
                  <mat-radio-button value="2">SMS</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          }
          <div class="row">
            @if (state) {
              <div class="col-md-12">
                <button mat-flat-button type="button" color="primary" class=" btn-block" (click)="checkLogin()">
                  @if (isLoading == false) {
                    <span>Avançar</span>
                  }
                  @if (isLoading == true) {
                    <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                  }
                </button>
              </div>
            }
            <div class="col-md-12">
              @if (!state && model.get('idHealthUnit').value) {
                <button mat-flat-button type="submit" color="primary" class=" btn-block">
                  @if (isLoading == false) {
                    <span>Enviar link de redefinição</span>
                  }
                  @if (isLoading == true) {
                    <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                  }
                </button>
              }

              <button mat-flat-button type="button" routerLink="/" color="accent" class=" btn-block">
                Voltar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>